import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { client } from '../../api/client';
import { RootState } from '../../app/store';
import { Identitet } from '../../models/identitet';
import { PaginatedResult } from '../../models/paginatedResult';
import { ThunkState, addHandlers } from '../../app/utils/reducerUtils';

type IdentitetListeState = ThunkState & {
    nextPage?: string;
    count?: number;
    query?: string | Identitet;
  }

const identitetListeAdapter = createEntityAdapter<Identitet>();

const initialState = identitetListeAdapter.getInitialState<IdentitetListeState>({
  pending: 'idle',
  errors: [],
});

// export const sokIdentitet = createAsyncThunk('identitet/sok', async (identitet: Identitet) => {
//   const response = await client.post<PaginatedResult<Identitet>>('identitet/sok', identitet);
//   return response.value;
// });


export const searchIdentiteter = createAsyncThunk('itentiteter/soekIdentitet', (query: string | Identitet) => {
  if (typeof query === 'object') {
    return client.post<PaginatedResult<Identitet>>('identitet/sok', query);
  }
  return client.get<PaginatedResult<Identitet>>(`identitet?q=${encodeURIComponent(query)}`);
});

export const loadIdentiteter = createAsyncThunk('identiteter/hentIdentiteter', async (pageUrl?: string) => {
    const response = await client.get<PaginatedResult<Identitet>>(pageUrl ?? 'identitet');
    return response;
  });

  export const createIdentitet = createAsyncThunk('identiteter/opprettIdentitet', async (identitet: Identitet) => {
    const response = await client.post<Identitet>('identitet', identitet);
    return response;
  });
  
  // export const updateIdentitet= createAsyncThunk('identiteter/oppdaterIdentitet', async (identitet: Identitet) => {
  //   const response = await client.post<Identitet>(`identitet/${identitet.id}`, identitet);
  //   return response;
  // });
  export const updateIdentitet= createAsyncThunk('identiteter/update', async (identitet: Identitet) => {
    const response = await client.post<Identitet>(`identitet/${identitet.id}`, identitet);
    return response;
  });

  export const removeIdentitet = createAsyncThunk('identiteter/fjernIdentitet', async (identitet: Identitet): Promise<void> => {
    await client.delete<void>(`identitet/${identitet.id}`);
  });

  export const identitetListeSlice = createSlice({
    name: 'identiteter',
    initialState,
    reducers: {
      refresh: () => initialState,
    },
    extraReducers: builder => {
      addHandlers({
        builder,
        thunk: loadIdentiteter,
        onSuccess(state, action) {
          state.count = action.payload.count;
          state.nextPage = action.payload.nextPage;
          identitetListeAdapter.upsertMany(state, action.payload.value);
        },
      });
      // addHandlers({
      //   builder,
      //   thunk: sokIdentitet,
      //   onSuccess(state, action) {          
      //     identitetListeAdapter.setAll(state, action.payload);
      //   },
      // });

      addHandlers({
        builder,
        thunk: searchIdentiteter,
        onPending(state, action) {
          state.count = undefined;
          state.query = action.meta.arg;
          state.nextPage = '';
          identitetListeAdapter.removeAll(state);
        },
        onSuccess(state, action) {
          state.count = action.payload.count;
          state.nextPage = action.payload.nextPage;
          identitetListeAdapter.setAll(state, action.payload.value);
        },
      });
      addHandlers({
        builder,
        thunk: updateIdentitet,
        onSuccess: (state, action) => {
          identitetListeAdapter.updateOne(state, {
            id: action.meta.arg.id,
            changes: action.payload,
          });
        }
      });
  
      addHandlers({
        builder,
        thunk: createIdentitet,
        onSuccess: (state, action) => {
          identitetListeAdapter.addOne(state, action);
        }
      });
  
      addHandlers({
        builder,
        thunk: removeIdentitet,
        onSuccess: (state, action) => {
          identitetListeAdapter.removeOne(state, action.meta.arg.id);
        }
      });
    },
  });

  export default identitetListeSlice.reducer;

export const {
  refresh
} = identitetListeSlice.actions;


export const {
  selectAll: selectIdentiteter,
  selectById: selectIdentitetById
} = identitetListeAdapter.getSelectors((state: RootState) => state.identiteter);